export enum EUserRole {
  ROLE_AGENT = 'ROLE_AGENT',
  ROLE_AGENCY_ADMIN = 'ROLE_AGENCY_ADMIN',
}
